<script setup>
const props = defineProps({
    plant_origins: Array,
    plant_foliages: Array,
    plant_flowering_seasons: Array,
    plant_types: Array,
    selected_filters: Object,
    initialSort: {
        type: String,
        default: 'title_asc',
    },
})

const sort = ref(props.initialSort)

const emit = defineEmits(['update'])

const updateFilters = (category, value) => {
    emit('update', category, value)
}

</script>

<template>
    <div id="shop-sort" class="offcanvas offcanvas-md">
        <div class="offcanvas__header">
            <h5 class="h3 offcanvas__title">
                <svg focusable="false" role="img">
                    <use xlink:href="/build/assets/icons.svg#sort" href="/build/assets/icons.svg#sort"/>
                </svg>
                Sort By
            </h5>
            <a class="btn-close" href="#" data-ec-dismiss="offcanvas">
                <span class="visually-hidden">Close</span>
            </a>
        </div>
        <div class="offcanvas__body">
            <div class="shop-sidebar__section">
                <div class="shop-sidebar__section__heading hidden-md">
                    <h3>Specials</h3>
                    <a href="#" class="shop-sidebar__clear" @click="clearFilter">Clear all</a>
                </div>
                <select
                    class="form-select"
                    aria-label="Product Sort"
                    v-model="sort"
                >
                    <option value="title_asc" selected>Product  (A-Z)</option>
                    <option value="title_desc">Product (Z-A)</option>
                    <option value="from_price_asc">Price (Low to High)</option>
                    <option value="from_price_desc">Price (High to Low)</option>
                </select>
            </div>
        </div>
    </div>
    <div id="shop-filter" class="offcanvas offcanvas-md">
        <div class="offcanvas__header">
            <h5 class="h3 offcanvas__title">
                <svg focusable="false" role="img">
                    <use xlink:href="/build/assets/icons.svg#refine" href="/build/assets/icons.svg#refine"/>
                </svg>
                Refine
            </h5>
            <a class="btn-close" href="#" data-ec-dismiss="offcanvas">
                <span class="visually-hidden">Close</span>
            </a>
        </div>
        <div class="offcanvas__body">

            <div class="shop-sidebar__section">
                <div class="shop-sidebar__section__heading">
                    <h3>Origin</h3>
                </div>
                <div class="form-check" v-for="plant_origin in plant_origins">
                    <input
                        class="form-check-input" type="checkbox"
                        :id="plant_origin"
                        :value="plant_origin"
                        :checked="selected_filters['origins'].includes(plant_origin)"
                        @change="updateFilters('origins', plant_origin)"
                    />
                    <label class="form-check-label" :for="plant_origin">{{ plant_origin }}</label>
                </div>
            </div>

            <div class="shop-sidebar__section">
                <div class="shop-sidebar__section__heading">
                    <h3>Foliage</h3>
                </div>
                <div class="form-check" v-for="plant_foliage in plant_foliages">
                    <input
                        class="form-check-input" type="checkbox"
                        :id="plant_foliage"
                        :value="plant_foliage"
                        :checked="selected_filters['foliages'].includes(plant_foliage)"
                        @change="updateFilters('foliages', plant_foliage)"
                    />
                    <label class="form-check-label" :for="plant_foliage">{{ plant_foliage }}</label>
                </div>
            </div>

            <div class="shop-sidebar__section">
                <div class="shop-sidebar__section__heading">
                    <h3>Flowering Season</h3>
                </div>
                <div class="form-check" v-for="plant_flowering_season in plant_flowering_seasons">
                    <input
                        class="form-check-input" type="checkbox"
                        :id="plant_flowering_season"
                        :value="plant_flowering_season"
                        :checked="selected_filters['flowering_seasons'].includes(plant_flowering_season)"
                        @change="updateFilters('flowering_seasons', plant_flowering_season)"
                    />
                    <label class="form-check-label" :for="plant_flowering_season">{{ plant_flowering_season }}</label>
                </div>
            </div>

            <div class="shop-sidebar__section">
                <div class="shop-sidebar__section__heading">
                    <h3>Plant type</h3>
                </div>
                <div class="form-check" v-for="plant_type in plant_types">
                    <input
                        class="form-check-input" type="checkbox"
                        :id="plant_type"
                        :value="plant_type"
                        :checked="selected_filters['plant_types'].includes(plant_type)"
                        @change="updateFilters('plant_types', plant_type)"
                    />
                    <label class="form-check-label" :for="plant_type">{{ plant_type }}</label>
                </div>
            </div>

        </div>
    </div>
</template>
